import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Card                                from '@material-ui/core/Card/Card'
import CardActions                         from '@material-ui/core/CardActions/CardActions'
import CardContent                         from '@material-ui/core/CardContent'
import CardHeader                          from '@material-ui/core/CardHeader'
import { InjectedFormikProps, withFormik } from 'formik'

import { AccountType }                                                from '../../api'
import { Communication }                                              from '../../redux/ducks'
import { capitalize }                                                 from '../../utils'
import { EnhancedTextField, InlineError, LoadingOverlay, Button }     from '../atoms'
import { genValueMapper, mapFormikToMuiProps, proxyFormikSubmission } from './form-utils'
import { emptyUser, inviteUserSchema }                                from './schemas'
import { FormikSubmissionCallBack }                                   from './types'

export interface InviteUserFields {
  email: string
}

interface CreateProgramPropsForm extends Communication {
  onSubmit: FormikSubmissionCallBack<InviteUserFields>
  accountType: AccountType
}

type Props = InjectedFormikProps<CreateProgramPropsForm, InviteUserFields>

class UserInviteForm extends React.Component<Props> {
  public componentDidUpdate ({ fetching: lastFetching }) {
    const { fetching, success } = this.props

    if (lastFetching && !fetching && success) {
      this.props.resetForm()
    }

    if (!lastFetching && fetching) {
      const activeElement = document.activeElement as HTMLElement

      if (activeElement && activeElement.blur) {
        activeElement.blur()
      }
    }
  }

  public render () {
    const {
      handleSubmit,
      accountType,
      error,
      fetching,
    } = this.props

    const capitalizedAccountType = capitalize(String(accountType))

    const phrasing = {
      createNewUser:
        (
          <FormattedMessage
            id={'generic.inviteUser'}
            values={{ userType: capitalizedAccountType }}
          />
        ),
      inviteUserPrompt:
        (
          <FormattedMessage
            id={'generic.inviteUserPrompt'}
            values={{ userType: capitalizedAccountType }}
          />
        ),
      invite:
        (
          <FormattedMessage
            id={'buttonActions.invite'}
          />
        ),
    }

    const submissionError = error && (
      <CardContent>
        <InlineError i18nErrorId={error} />
      </CardContent>
    )

    const mapper = mapFormikToMuiProps(this.props)

    return (
      <form onSubmit={handleSubmit}>
        <LoadingOverlay show={fetching}>
          <Card>
            <CardHeader
              title={phrasing.createNewUser}
              subheader={phrasing.inviteUserPrompt}
            />
            <CardContent>
              <EnhancedTextField
                fullWidth
                {...mapper('email')}
              />
            </CardContent>

            {submissionError}

            <CardActions>
              <Button
                type={'submit'}
                color={'secondary'}
                variant={'raised'}
              >
                {phrasing.invite}
              </Button>
            </CardActions>
          </Card>
        </LoadingOverlay>
      </form>
    )
  }
}

export default withFormik<CreateProgramPropsForm, InviteUserFields>({
  mapPropsToValues: genValueMapper(emptyUser),
  validationSchema: inviteUserSchema,
  handleSubmit:     proxyFormikSubmission,
})(UserInviteForm)



// WEBPACK FOOTER //
// ./src/components/forms/UserInviteForm.tsx